<template>
    <div>
        <Header>
        </Header>

        <div class="page page--narrow">
            <h3 class="h3" v-t="'Get a Custom Domain'"></h3>
            <div class="block block--account">

                <p v-t="'Enter a domain name below to check its availability.'"></p>


                <field :errors="errors" label="Domain" name="newDomain">
                    <input v-model="newDomain" type="text">
                    <span v-if="status=='available'" class="field-passed"><i v-t="'Domain Available'"></i></span>
                    <span v-if="status=='unavailable'" class="field-failed"><i v-t="'Domain not available'"></i></span>
                    <span v-if="status=='checking'" class="field-checking"><i v-t="'Checking... '"></i></span>
                    <span v-if="status=='invalid'" class="field-failed"><i v-t="'Invalid format (example.com)'"></i></span>
                    <span v-if="status=='invalid_tld'" class="field-failed"><i v-t="'Unsupported extension, chat to us!'"></i></span>
                </field>

                <p class="small" v-t="'Domain names should end in .com, .net, .org, .co.uk, .us, .info, .me, .ca, .com.au, .eu, .fr, .de or .in. Interested in another domain? Chat with us.'"></p>

                <button @click="$parent.upgradeModal('pro')" v-if="portfolio.account_type=='free'&&status=='available'" v-t="'Upgrade to Pro'"></button>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Field from '@/components/Field.vue'
    import domainService from '@/services/domainService.js'

    export default {
        name: 'articles_list',
        components: {
            Header,
            Field,
        },
        data () {
            return {
                errors: {},
                newDomain: '',
                status: null

            }
        },
        watch: {
            newDomain () {
                this.status = 'checking';
                domainService.check(this.newDomain).then(result => {
                    this.status = result;
                })
            },
            portfolio (){
                this.newDomain = this.portfolio.wanted_domain
            }
        },
        computed: {
            user () {
                return this.$store.getters['auth/user']
            },
            portfolio () {
                return this.$store.getters['portfolio/portfolio']
            }
        },
    }
</script>